// 工具函数
export var findParent = function (e) {
    var _a;
    var parent = e.parentNode;
    while (parent) {
        var next = parent;
        if ((_a = next === null || next === void 0 ? void 0 : next.dataset) === null || _a === void 0 ? void 0 : _a.log) {
            return next;
        }
        parent = parent.parentNode;
    }
};
export var doReports = function (m, callbackDict) {
    Object.keys(callbackDict).forEach(function (key) {
        var call = callbackDict[key];
        var aliveFilter = m.filterPoint['alive'];
        if (aliveFilter) {
            if (aliveFilter === key) {
                call && call(m);
            }
        }
        else {
            call && call(m);
        }
    });
};
//# sourceMappingURL=util.js.map